(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire77dd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire77dd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("451Sc", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $2f891507bcc3501a$export$6503ec6e8aabbaf; }, function (v) { return $2f891507bcc3501a$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $2f891507bcc3501a$export$f7ad0328861e2f03; }, function (v) { return $2f891507bcc3501a$export$f7ad0328861e2f03 = v; });
var $2f891507bcc3501a$export$6503ec6e8aabbaf;
var $2f891507bcc3501a$export$f7ad0328861e2f03;
"use strict";
var $2f891507bcc3501a$var$mapping = new Map();
function $2f891507bcc3501a$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$2f891507bcc3501a$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $2f891507bcc3501a$var$resolve(id) {
    var resolved = $2f891507bcc3501a$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$2f891507bcc3501a$export$6503ec6e8aabbaf = $2f891507bcc3501a$var$register;
$2f891507bcc3501a$export$f7ad0328861e2f03 = $2f891507bcc3501a$var$resolve;

});

parcelRegister("i1aqH", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $d1e0691a4ecd19e1$export$bdfd709ae4826697; }, function (v) { return $d1e0691a4ecd19e1$export$bdfd709ae4826697 = v; });
var $d1e0691a4ecd19e1$export$bdfd709ae4826697;
var $d1e0691a4ecd19e1$export$c9e73fbda7da57b6;
var $d1e0691a4ecd19e1$export$5a759dc7a1cfb72a;
"use strict";
var $d1e0691a4ecd19e1$var$bundleURL = {};
function $d1e0691a4ecd19e1$var$getBundleURLCached(id) {
    var value = $d1e0691a4ecd19e1$var$bundleURL[id];
    if (!value) {
        value = $d1e0691a4ecd19e1$var$getBundleURL();
        $d1e0691a4ecd19e1$var$bundleURL[id] = value;
    }
    return value;
}
function $d1e0691a4ecd19e1$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $d1e0691a4ecd19e1$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $d1e0691a4ecd19e1$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $d1e0691a4ecd19e1$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$d1e0691a4ecd19e1$export$bdfd709ae4826697 = $d1e0691a4ecd19e1$var$getBundleURLCached;
$d1e0691a4ecd19e1$export$c9e73fbda7da57b6 = $d1e0691a4ecd19e1$var$getBaseURL;
$d1e0691a4ecd19e1$export$5a759dc7a1cfb72a = $d1e0691a4ecd19e1$var$getOrigin;

});

var $005e11f2de40dece$exports = {};


(parcelRequire("451Sc")).register((parcelRequire("i1aqH")).getBundleURL("a3HC9"), JSON.parse('["a3HC9","index.c3d34daa.js","3pdR1","brand_logo.9eab8eb5.png","5Whcg","Grocery.647a33e8.js","2sRFk","index.a1cbf038.css"]'));

})();
//# sourceMappingURL=index.runtime.ce5c8b8f.js.map
